export default {
  App: {
    title: {
      notfound: '页面找不到了',
      loading: 'Global Ordering Platform',
      login: '登录 - iFi Audio',
      streamqrcode: 'iFi Stream app - iFi Audio',
      gaiaapp: 'iFi Gaia app - iFi Audio',
      nexisapp: 'iFi Nexis app - iFi Audio',
      home: 'Global Ordering Platform',
      details: '商品详情 - iFi Audio',
      cart: '购物车 - iFi Audio',
      orderconfirm: '订单确认 - iFi Audio',
      orderform: '订单信息 - iFi Audio',
      console: '控制台 - iFi Audio',
      center: '个人中心 - iFi Audio',
    },
    notify: {
      title_server: '服务器',
      title_success: '成功',
      content_server: '服务器超时，错误代码：',
      content_servererr: '网络状态差，请求被拒绝',
      content_k3error: 'K3系统出现异常，请联系管理员',
      conten_k3err_dts: 'K3系统配置异常：',
      content_k3exchangeerr:
        'K3系统汇率体系已过期，请联系财务更新(销售订单汇率为必录项)，如已更新，请检查客户组织分配问题',
      content_carterr: '购物车服务器出现异常，请联系管理员',
      title_retry: '重试',
      content_loginerr: '账号不存在或密码错误',
      title_nofity: '通知',
      content_testversion: '欢迎登录，所有服务已启动',
      title_warning: '警告',
      content_illegal: '用户非法操作',
      content_illegal_params: '非法参数',
      title_err: '错误',
      content_unknownerr: '未知错误',
      content_user_disabled: '账户已被禁止登录',
      content_noresult: '没有任何查询结果',
      content_redudancy: '请联系系统管理员以确认订单详细情况。',
      content_entitiesept: '资源服务错误，请联系管理员',
      content_no_item: '没有查询到任何数据',
      content_no_tracking: '没有同步到任何物流信息',
      content_jpgonly: '仅支持jpg/png',
      content_uploadlmt: '上传的文件超出大小限制',
      span_no_notification: '暂无通知',
      content_optsuccess: '操作成功',
      content_country_null: '拉取国家列表失败，请注销后重新登录再试',
      content_redundancy: '请求没有完全成功，请联系管理员反馈此情况！',
      notice_auto_logist_err: ' 若自动识别单号失败，请您手动选择物流公司。',
      notification_neworder_title: '有新的订单',
      notification_neworder_body: '你在商城有新订单，请及时处理。',
      init_notification_title: 'iFi商城',
      init_notification_body: '已启用新订单提醒',
      loginviadingtalk: '您使用钉钉成功登录系统后台',
      ntf_uptodate: '已更新',
      loginviapass: '推荐绑定钉钉账号一键登录获得最佳体验',
      vpn_network_err:
        '如长时间无法更新数据或提示网络错误，请检查网络和VPN是否正常。',
      wbstore_saleorg:
        "所有Webstore的订单的销售组织默认为'AL'并且谷仓订单为标准订单。",
      spstore_saleorg:
        "所有Shopify的订单的销售组织默认为'AGL'并且谷仓订单为标准订单。",
      msg_required: '信息不全。',
      refresh: '数据已更新，请刷新页面',
      notify_exist: '数据已存在',
    },
    verify: {
      username_required: '请输入账号',
      username_length: '用户名长度在2-15之间',
      password_required: '请输入密码',
      password_length: '密码长度在3-15之间',
    },
    text: {
      placeholder: '请输入...',
      placeholder_tag_shippingadd: '如：家，公司',
      placeholder_notes: '留言：',
      placeholder_select: '请选择...',
      placeholder_search: '搜索...',
      phd_username: '请输入用户名',
      phd_password: '请输入密码',
      username: '用户名',
      password: '密码',
      dologin: '登录',
      loading: '加载中...',
      search: '搜索',
      done: '确 定',
      cancel: '取 消',
      update: '更 新',
      login_alert:
        '为了保证您的良好体验，请使用谷歌浏览器、Safari浏览器、火狐浏览器、欧朋浏览器、Edge浏览器打开页面。',
      ikonw: '我知道了',
      usd_abbr: '美元',
      rmb_abbr: '元',
      kg_abbr: '千克',
      submit: '提交',
      start_date: '开始日期',
      end_date: '结束日期',
      range_separator: '至',
      last_a_week: '最近一周',
      last_a_month: '最近一个月',
      last_three_months: '最近三个月',
      score: '分值',
      hi: 'Hi, ',
      'utc+8': '东八区-UTC+8',
      not_bound: '未绑定',
      save: '保存',
      month: '月',
      out_of_sale: '已下架商品',
      yes: '是',
      no: '否',
      beta: '测试版',
      checkall: '全选',
      load_info: '获取信息中',
      copy_success: '已复制',
      clicktocopy: '点击复制',
      wb_statuses: '状态: ',
      wb_downloaded: '已下载',
      wb_checked: '已审核',
      wb_callbacked: '已回传',
      wb_arrived: '已送达',
      s_fulfilled: '已同步',
      wb_canceled: '已取消',
      wb_refunded: '已退款',
      wb_followed: '已处理',
      txt_enabled: '启用',
      text_disabled: '禁用',
      txt_deactivated: '停用',
      edit: '编辑',
      push: "推送"
    },
    tabs: {
      international_customer: '国际客户',
      domestic_customer: '中国客户',
      international_order: '国际订单',
      domestic_order: '中国订单',
      quickordering: '快速下单',
      'w-order': 'Webstore订单',
      shopify: 'Shopify',
      globalemail: '邮件通知',
      synproducts: '产品列表',
      pricingrules: '计价规则',
      discountrules: '折扣率规则',
      pricesystem: 'Master Pack价格配置',
      standardorder: '标准订单',
      webstoreorder: 'eCommerce订单',
      country: '区域',
      payment: '付款方式',
      currency: '币种',
      orderstatus: '订单状态',
      brand: '品牌',
      satisfacationsurvey: '调查结果',
      serialnumbertool: '序列号检索工具',
      analysis: '分析',
      mysetting: '个人设置',
      shopifyorder: 'shopify订单',
    },
    view: {
      custCommonHead: {
        router_logout: '注销',
        router_custhome: '个人中心',
        router_cart: '购物车',
        head_notice:
          '温馨提示：中国春节期间（1月27日-2月10日），订单处理可能会出现延迟，请您提前安排好您的订单计划，不便之处敬请谅解！',
      },
      consolesetting: {
        title_basic: '基本资料',
        title_dingtalk: '钉钉信息',
        title_k3: 'K3信息',
        label_username: '用户名',
        label_sex: '性别',
        label_tel: '联系电话',
        label_email: '邮箱',
        label_name: '姓名全称',
        label_alias: '英文名称',
        label_dingtalk_userid: '钉钉ID',
        label_dingtalk_staffname: '钉钉姓名',
        label_k3_account: 'K3账号',
        label_k3_pass: 'K3密码',
        label_k3_salesid: 'K3编号',
        notify_info_null: '所有信息都是必填项',
        resetpass: '重置密码',
        notify_sales_err: '部分信息保存失败',
        text_saveinfo_title: '提示',
        text_saveinfo_body:
          '钉钉信息和K3信息一旦有误，将影响订单和产品操作，请确认无误后保存！',
      },
      customer: {
        tab_customer: '客户',
        btn_synchronize: '同步数据',
        btn_register: '创建',
        empty_customer: "点击'同步数据'按钮以获取客户列表",
        label_username: '用户名',
        label_name: '客户全称',
        label_alias: '客户别名',
        label_paymentterms: '付款方式',
        label_country: '区域',
        label_discount: '折扣率(0~1)',
        label_minweight: '最少下单重量',
        label_minamount: '最少下单金额',
        label_k3id: 'K3客户编码',
        label_password: '密码',
        label_sex: '性别',
        label_tel: '电话',
        label_email: '邮箱',
        label_type: '用户类型',
        label_general: '常规客户',
        label_brand: '品牌范围',
        label_ifi: 'iFi',
        label_sl: 'Silent Power',
        label_allb: 'iFi&Silent Power',
        label_mo: 'MO用户',
        label_shippingaddress: '收货地址',
        label_invoiceaddress: '发票地址',
        label_status: '状态',
        label_options: '选项',
        tooltip_username:
          '用户名在设置后不可更改，可以使用字母，数字，半角符号，并且在2-15字符内',
        tooltip_name: '设置客户全称',
        tooltip_alias: '设置客户别名',
        tooltip_currency: '选择结算币种',
        tooltip_paymentterms: '选择付款方式',
        tooltip_country: '选择区域',
        tooltip_discount: '设置客户的折扣率',
        tooltip_minweight: '设置最少下单重量',
        tooltip_minamount: '设置最少下单金额',
        tooltip_k3id: 'K3系统绑定的客户编码',
        tooltip_password: '密码应在3-15个字符内',
        tooltip_sex: '选择客户性别',
        tooltip_tel: '设置客户的联系电话',
        tooltip_email: '设置客户邮箱以接收平台邮件推送',
        title_modifycust: '的资料',
        label_male: '男',
        label_female: '女',
        notify_countrysession_err_code: 'Error code:-17',
        notify_countrysession_err:
          '基础资料列表获取失败，请尝试注销后重新登录，若问题持续，请联系管理员',
        button_doedit: '保存',
        button_doregister: '立即注册',
        button_docancel: '取消',
        message_success: '保存成功',
        register_dialog_title: '创建客户',
        notify_normal_err_code: 'Error code: -1',
        notify_username_length: '用户名应在2-15个字符内',
        notify_password_length: '密码应在3-15个字符内',
        notify_register_null: '注册信息不完整',
        notify_address_null: '信息不完整',
        notify_username_repeatly: '该用户名已存在，请确认',
        span_username_repeatly: '该用户名已存在，请确认',
        notify_username_repeatly_tryagain:
          '用户名已存在，刷新页面或重新登录系统再试',

        notify_email_error: '邮箱格式错误',
        shipping_dialog_title: '管理收货地址',
        receipt_dialog_title: '管理发票地址',
        delete_address_success: '已删除',
        message_cancel: '已取消',
        btn_message_confirm: '确认',
        btn_message_cancel: '不，取消',
        text_delete_message_body: '真的要删除吗？',
        text_delete_message_title: '请确认',
        notify_title_notification: '信息',
        notify_full_address: '最多可以保存10条地址信息',
        notify_warn: '警告',
        notify_full_address_java: '最多可以保存10条地址信息！请勿非法操作！',
        notice_delete_user: ' 当前用户无法删除客户，如需操作请联系管理员授权',
        title_add_address: '新增地址',
        title_edit_address: '修改地址',
        label_company: '公司',
        label_contacts: '联系人',
        label_province: '省/州',
        label_city: '城市',
        label_zipcode: '邮编',
        label_address: '地址',
        label_add_tel: '联系电话',
        label_add_email: '联系邮箱',
        label_tag: '标签',
        label_taxno: '税号',
        btn_save: '保存',
        empty_address: "没有任何地址，点击' + '创建一个新地址",
        notify_least_over1: '最少下单重量和金额不能为0。',
      },
      order: {
        radio_orderlist_all: '全部',
        radio_orderlist_processing: '待确认',
        radio_orderlist_finished: '已完成',
        radio_orderlist_mo: 'MO订单',
        label_order_number: '实体:',
        label_order_createtime: '创建时间:',
        label_order_proccessing: '未完成',
        label_group_title_basic: '基本信息',
        label_group_title_shipping: '物流信息',
        label_group_title_receipt: '形式发票信息',
        label_group_title_payment: '付款信息',
        label_group_title_document: '出货信息',
        label_group_title_details: '订单详情',
        label_group_title_delivery: '交付',
        label_group_title_list: '发货清单',
        label_orderstatus: '订单状态:',
        label_orderstatus_next: '下个状态:',
        label_orderid: '实体:',
        label_orderfid: 'K3订单编号:',
        label_custpo: '客户订单编号:',
        label_delivery: '交货方式:',
        label_org: '销售组织:',
        label_contacts: '联系人:',
        label_company: '公司:',
        label_address: '地址:',
        label_province: '省/州:',
        label_city: '城市:',
        label_zipcode: '邮编:',
        label_country: '区域:',
        label_tel: '电话:',
        label_email: '邮箱:',
        label_taxno: '税号:',
        tooltip_editdelivery: '点击修改交货方式',
        span_upload_receipt: '上传形式发票',
        span_no_payment: '用户暂未上传付款凭证，或你已选择跳过。',
        span_upload_packinglist: '上传装箱单',
        span_upload_commercial: '上传商业发票',
        label_remark: '订单留言/备注:',
        btn_addition_product: '添加产品',
        placeholder_addition: '请输入K3物料编码',
        notify_addition_willdo:
          '已查找到该产品，点击确认后将以0折扣率添加到本订单中，数量为1，并更新总价，确认添加吗？',
        notify_addition_notfound:
          '对不起，您输入的K3物料编码未核对到任何产品，请检查！',
        notify_addition_success:
          '添加成功，该产品折扣率为0数量为1，如有需要请自行修改，1秒后即将刷新',
        productimage: '产品图片',
        productname: '产品名称',
        productprice: '价格',
        productdiscount: '折扣率(%)',
        productdisprice: '折后价',
        productquantity: '数量',
        productsubweight: '重量(Kg)',
        productsubprice: '小计',
        label_options: '选项',
        total_product: '产品总数:',
        total_quantity: '数量总数:',
        weight_total: '总重量:',
        order_total: '总计:',
        order_weight: '重量:',
        btn_refresh_order: '刷新订单',
        btn_set_org: '重设销售组织',
        btn_order_checkedup: '审核',
        btn_order_recall: '撤回',
        btn_files_manage: '管理文件',
        btn_closeorder: '关闭',
        btn_cancalorder: '取消',
        popover_orderrecord: '需要查看该订单操作记录吗?该功能正在开发中...',
        text_pickupbyseller:
          '客户选择了自提货物，该订单物流由买家负责，无需填写出货信息。',
        label_logistics_no: '物流单号:',
        label_logistics_company: '物流公司:',
        label_products_batch: '产品:',
        label_table_prodname: '名称',
        label_table_prodquantity: '数量',
        btn_savebatchprod: '保存',
        text_not_select_order: '选择一个订单以查看详情。',
        notify_k3order_success: '订单已成功同步至K3系统！',
        btn_upload: '上传',
        text_docheckorder_message_title: '信息',
        text_docheckorder_message_body:
          '确认将订单添加到K3系统吗？添加成功后将不可更改交货方式、备注等信息！',
        text_cancelorder_message_body:
          '取消订单后订单将会从商城后台和客户的订单列表消失，请谨慎操作！如需删除K3订单，请手动操作！',
        text_recallorder_message_body:
          '撤回订单将会将订单重置为未审核状态，但不会删除已写入K3的订单，继续吗？',
        text_closeorder_message_body:
          '您正在直接关闭该订单，系统会把订单置为已完成状态并且不会通知客户。',
        message_cancel: '已取消',
        btn_message_confirm: '确认',
        btn_message_cancel: '不，取消',
        btn_proformainvoice_nextstep: '完成',
        notify_enterproformainvoice_success: '发票上传已确认完成',
        notify_skipto_step4_monthly:
          '由于客户的付款方式是月付类型，已自动跳过付款凭证的上传。',
        link_modify: '修改',
        span_monthly_payment:
          '由于客户的付款方式是月付类型，该订单无须上传付款凭证',
        btn_skip: '跳过',
        text_skipbankslip_message_body: '确认要跳过吗？',
        notify_skipbankslip_success: '跳过成功！',
        btn_confirm: '确认',
        notify_confirm_banslip_success: '确认成功',
        text_confirmbankslip_message_body: '你想确认付款信息吗？',
        btn_update_k3_deliveryorder: '刷新出库单信息',
        btn_delivery_start: '填写出货信息',
        btn_sign: '确认订单',
        tag_noticemodifydetails:
          ' 注意：你可以设置产品的任意折扣和数量，请认真检查你设置的值！',
        tag_notice_checkedup_modify:
          ' 注意：如果您在该订单审核后修改了产品数量或折扣，请手动进入K3系统做相同修改，并仔细核对结果！',
        text_delivery_message_body:
          '你想把该订单的产品标记为发货状态吗？此操作不可逆！',
        text_delivert_message_title: '警告',
        notify_delivery_success: '操作成功，你现在可以完善物流信息。',
        notify_outstock_success: '出货成功',
        text_batchproduct_message_body:
          '确认出货吗？请认真检查出货产品和数量是否匹配，此操作不可逆！',
        text_sign_message_title: '信息',
        text_sign_message_body:
          '客户可能还没有收到产品，你想确认完成该订单吗？订单将会被标记成已完成状态。',
        notify_sign_success: '订单确认成功',
        text_logistics_no: '物流单号:',
        text_logistics_company: '物流公司:',
        text_time: '时间:',
        text_download: '下载',
        text_remove: '移除',
        text_editlogistics_body:
          '你想保存新的物流单号吗？系统将会立即刷新物流信息！',
        notify_editlogistics_success: '物流信息将会重新加载',
        title_tracking: '物流跟踪：',
        text_editdelivery_prompt_body: '请选择交货方式',
        text_check_file_title: '文件管理',
        text_select_org: '选择销售组织',
        text_editdelivery_prompt_null: '必须选择一项交货方式。',
        text_editdelivery_nomodify: '无变化',
        label_select_termsa: '买家自提',
        label_select_termsb: '卖家发货',
        label_sale_org: '销售组织',
        notify_editdelivery_success: '交货方式已被修改',
        btn_gettracking: '获取',
        text_track_tip: "点击'获取'按钮来获取物流跟踪信息",
        notify_one_detail_least: '至少保留一个产品',
        text_remove_details: '确认删除该产品吗？此操作不可逆！',
        dialog_selectproducts: '请勾选发货项目',
        btn_iconfirmed: '我已确认',
        text_modifyprice: '存在代理商价格的产品，请手动修改价格！',
        notify_weighttotal_err: '订单重量加载失败！',
        notify_record_err: '日志变更失败！',
        title_pi: '形式发票',
        title_pt: '付款凭证',
        title_pl: '装箱单',
        title_ci: '商业发票',
        title_newfile: '新增附件',
        label_select_filetype: '文件类型',
        label_select_file: '选择文件',
        notify_upload_newfile: '文件类型和文件都是必需项目',
        text_remove_file_body: '确定移除该文件吗？移除后文件不可恢复',
        notify_orderline_pi: '必须首先在订单流程上上传形式发票',
        notify_orderline_pt: '必须首先在订单流程上上传付款凭证',
        notify_orderline_pl: '必须首先在订单流程上上传装箱单',
        notify_orderline_ci: '必须首先在订单流程上上传商业发票',
        notify_updatenotes: '后台修改备注/留言成功',
        notify_org_required: '必须选择一项组织！',
        notify_org_saved: '已保存，请审核订单。',
      },
      quickordering: {
        btn_quick_submit: '创建订单',
        label_customer: '客户',
        label_details: '产品',
        title_p_adder: '添加产品',
        btn_addtoorder: '确认添加',
        lebel_subweight: '小计(重量)',
        text_order_done: '确定提交订单吗？',
        unfinished_order: '订单信息不完整。',
        switch_default_discount: '使用默认折扣率',
      },
      property: {
        tab_country: '区域',
        tab_paymentterms: '付款方式',
        tab_orderstatus: '订单状态',
        tag_forcerefresh: ' 更改前请同步最新数据。',
        tag_paymenttype: ' 是否月付 = 1：月付，是否月付 = 0：非月付',
        button_refresh: '更新资料',
        button_addrow: '新增',
        label_c_namecn: '中文名称',
        label_c_nameen: '英文名称',
        label_gc_code: '3PL-区域代码',
        label_c_code: '区域代码',
        label_os_priority: '优先级',
        label_os_doingcn: '进行状态(中文)',
        label_os_doingen: '进行状态(英文)',
        label_os_donecn: '完成状态(中文)',
        label_os_doneen: '完成状态(英文)',
        label_pt_contentcn: '付款方式(英文)',
        label_pt_contenten: '付款方式(中文)',
        label_pt_type: '是否月付',
        label_options: '选项',
        label_pt_currencyname: '名称',
        label_pt_currencynameen: '名称(英文)',
        label_pt_currencysign: '符号',
        label_pt_currencyabbr: '货币缩写/K3币别标识',
      },
      synproducts: {
        waitfork3: '从K3加载数据中...',
        tab_synproducts: '产品列表',
        label_pd_sysname: 'BOM名称',
        label_pd_name: '展示名称',
        label_pd_brand: '品牌',
        label_pd_img: '产品图片',
        label_pd_sign: '币别',
        label_pd_k3code: 'K3物料编码',
        label_pd_saleprice: '销售价格（国际）',
        label_pd_saleprice_cn: '销售价格（国内）',
        label_pd_weight: '单位净重',
        label_pd_rweight: 'Bulk 整箱重量',
        label_pd_g_sku: '3PL SKU',
        label_pd_sku: 'SKU No.',
        label_pd_ean: 'EAN/Barcode',
        label_pd_boxpcs: 'Bulk 产品数量/箱',
        master_pack: 'Master Pack标准箱数量',
        master_carton: 'Master Carton箱数量',
        label_pd_feature: 'Master Pack尺寸',
        mcsize: "Bulk Carton尺寸",
        label_pd_isshow: '是否上架（国际）',
        label_pd_isshow_cn: '是否上架（国内）',
        // label_pd_prices: "欧元阶梯价格",
        label_pd_prices: '价格设置',
        label_pd_blacklist: '屏蔽列表',
        label_pd_description: '产品描述',
        btn_pd_prices: '价格(币种)',
        btn_pd_prices_2: '价格(阶梯)',
        staged_qty: '阶梯数量',
        check_pd_newprice: '启用新价格体系',
        btn_pd_blacklist: '点击设置黑名单',
        title_blacklist: '屏蔽的用户列表',
        alert_blacklist: '黑名单的设置同时在国内/国际版本生效，请确认设置',
        alert_blacklist_2: '勾选状态表示当前客户无法看见该产品',
        label_inter_cust: '国际客户',
        label_dome_cust: '国内客户',
        btn_loadfromk3: '从K3同步产品',
        empty_products: "点击'从K3同步产品'按钮以获取产品列表",
        tooltip_sysname: '产品的原生名称',
        tooltip_name: '产品的展示名称',
        tooltip_saleprice: '产品的销售价格',
        tooltip_weight: '单个产品的标准重量',
        tooltip_rweight: '一箱产品的标准重量',
        tooltip_g_sku: '3PL SKU',
        tooltip_sku: 'SKU No.',
        tooltip_ean: 'EAN/Barcode',
        tooltip_boxpcs: '装入一箱产品的数量',
        tooltip_feature: '包装箱尺寸',
        tooltip_isshow: '调整产品是否上架到商城',
        tooltip_description: '添加产品描述',
        button_doedit_product: '保存',
        button_docancel_product: '取消',
        button_batchsell: '批量上架/下架',
        radio_product_all: '全部',
        radio_product_on: '上架',
        radio_product_off: '下架',
        message_batchsuccess: '操作成功',
        span_upload_body1: '将文件拖到此处，或',
        span_upload_body2: '点击上传',
        span_tip_upload: '仅支持jpg/png，且文件大小在5MB以内',
        message_success: '保存成功',
        notify_connected_k3system: '与K3系统通讯失败，请立即联系管理员！',
        radio_rand_ifi: 'iFi',
        radio_rand_silentpower: 'Silent Power',
        master_pack_qty_tip: '将覆盖Master Pack标准箱数量字段，请检查设置',
        updateInfoByPMS: "PMS更新基础数据"
      },
      pricingrules: {
        tab_ruleslist: '规则列表',
        tag_price_currency: ' 设置价格默认的币种为美元',
        button_refresh: '更新资料',
        button_addrow: '新增',
        title_new_rules: '新增规则',
        title_set_customer: '设置客户',
        label_product: '产品',
        label_price: '价格(美元)',
        label_customers: '适用客户',
        text_remove_rule: '确认删除这条规则吗？此操作不可逆！',
        notify_additems_null: '新增项目全部为必填项！',
        notify_price_nochanges: '设置的价格不能与该产品的默认价格一致！',
      },
      discountrules: {
        label_discount: '折扣率(0-1%)',
        notify_discount_range: '折扣率必须为0-1之间的小数',
      },
      brand: {
        button_refresh: '更新资料',
        button_add: '新增',
        label_id: 'ID',
        label_name: '品牌名称',
        label_brandCode: '品牌编码',
        label_options: '操作',
        notify_name_required: '品牌名称不能为空',
        notify_brandCode_required: '品牌编码不能为空',
        text_confirm_delete: '当前品牌关联的所有客户品牌折扣将自动失效，产品品牌属性将清空，且无法恢复，确认删除？',
      },
      pricesystem: {
        button_refresh: '更新资料',
        button_add: '新增',
        button_copy: '复制',
        button_export: '导出',
        button_delete: '删除',
        title_add: '新增价格体系',
        title_edit: '编辑价格体系',
        title_copy: '复制价格体系',
        label_id: 'ID',
        label_name: 'Master Pack 价格体系',
        label_currency: '币种',
        label_total_product: '绑定产品数量',
        label_active_product: '产品启用数量',
        label_status: '状态',
        label_updated_by: '最后修改人',
        label_updated_time: '最后修改时间',
        label_options: '操作',
        notify_required: '价格体系名称和币种为必填项',
        notify_name_exists: '该价格体系名称已存在，不允许重复',
        notify_referenced: '该价格体系已被客户引用，不允许删除',
        text_confirm_delete: '确认删除吗？此操作不可恢复！',
      },
      pricesystemdetail: {
        title_add: '新增 Master Pack 价格体系',
        title_edit: '编辑 Master Pack 价格体系',
        title_detail: 'Master Pack 价格体系详情',
        title_product_list: '产品列表',
        title_import: '导入产品',
        button_add_product: '新增产品',
        button_sync_product: '同步产品',
        button_import: '导入',
        button_export: '导出',
        button_select_file: '选择文件',
        phd_search_product: '产品名称/编码',
        col_product_name: '产品名称',
        col_product_code: '产品编码',
        col_standard_pack_qty: 'Master Pack 标准箱数量',
        col_master_pack_size: 'Master Pack 尺寸',
        col_single_unit_price: 'Single Unit Price',
        col_master_pack_price: 'Master Pack Price',
        col_master_pack_qty: 'Master Pack QTY',
        col_master_carton_price: 'Master Carton Price',
        col_master_carton_qty: 'Master Carton QTY',
        notify_row_incomplete: '请完善第 ',
        notify_row_incomplete_suffix: ' 行数据',
        notify_product_list_empty: '产品列表不能为空',
        notify_select_file: '请选择导入文件',
        notify_save_first: '请先保存价格体系后再导出',
        notify_no_products: '产品数量为空',
        span_upload_body1: '将文件拖到此处，或',
        span_upload_body2: '点击上传',
        upload_tip_xlsx: '仅支持 .xlsx / .xls 格式文件',
        notify_all_synced: "所有产品已同步成功"
      },
      globalemail: {
        tab_globalemail: '全局',
        tag_forcedelete: ' 自定义邮件设置中，每个邮箱只能设置一种通知方式',
        tab_custom: '自定义',
        label_email: '邮箱',
        label_countries: '区域',
        label_cust: '客户',
        label_exception_countries: '黑名单',
        button_refresh: '更新资料',
        button_addrow: '新增',
        label_options: '选项',
        notify_one_email_least: '至少保留一个邮箱地址',
        title_new_global_email: '新增全局邮箱',
        title_new_costom_email: '新增自定义邮箱',
        notify_email_null: '邮箱地址不能为空',
        notify_country_null: '区域不能为空',
        content_email_repeatly: '该邮箱已存在，请勿重复设置！',
        title_setcountry: '设置区域',
        title_setblacklist: '设置黑名单',
        title_setcust: '设置客户',
        text_remove_email: '确认删除该邮箱吗？此操作不可逆！',
        notify_changetype1:
          '当前操作将会保存邮箱设置的区域，且会删除配置的客户信息，继续吗？',
        notify_changetype2:
          '当前操作将会保存邮箱设置的客户，且会删除配置的区域信息，继续吗？',
        notify_least1_checked: '至少选择一项后再保存！',
      },
      survey: {
        empty_explain: '  暂时还没有反馈结果！',
      },
      '3pl': {
        tab_standardorder: '标准订单',
        button_querylocal: '下载',
        button_synchrnize: '同步',
        button_updatefid: '更新状态',
        no_notifyorder_update: '发货通知单已是最新！',
        notifyorder_update_1: '从K3获取了 ',
        notifyorder_update_2: ' 条新的发货通知单！',
        empty_order: "点击'从K3同步发货通知单'按钮以获取数据",
        label_notifyorder: '发货通知单号',
        label_order: '销售订单号',
        label_contacts: '联系人姓名',
        label_g_w_code: '谷仓发货仓库代码',
        label_status: '当前状态',
        label_option: '操作',
        notify_rollback_k3_err1:
          '其他人正在使用发货通知单，未能全部更新，请稍后再试',
        status_0: '未同步',
        status_1: '已同步',
        status_2: '已回传',
        status_3: '已完成',
        notify_outofstock:
          '该发货仓在谷仓系统中库存不够或SKU不存在！(请检查K3谷仓字段是否完整)',
        text_upload_standard_sorder: '上传至谷仓',
        text_callbackinfo: '从谷仓拉取信息',
        text_savetok3: '保存至K3',
        text_view_details: '查看详情',
        notify_ordercode_insys:
          '(请勿关闭)数据已上传至谷仓，谷仓订单号同步至系统失败，请立即联系管理员手动添加谷仓订单号：',
        notify_callbackinfo_success: '订单数据拉取成功！',
        notify_no_sn_update: '谷仓反馈序列号资料暂未更新',
        notify_some_sns_notuptodate:
          '部分序列号更新失败，请仔细核对序列号并联系管理员',
        notify_savek3_success: '已成功保存到K3的销售出库单',
        explain_status0: '未同步：表示此发货通知单未同步到谷仓的标准订单。',
        explain_status1:
          '已同步：表示此发货通知单已同步到谷仓标准订单的草稿状态。',
        explain_status2:
          '已回传：表示谷仓已经回传该订单的运单编号和序列号列表并且数据已储存到商城。',
        explain_status3: '已完成：表示该订单的序列号列表已保存至K3。',
        label_details: '明细：',
        label_quantity: '数量',
      },
      aftersales: {
        tab_sntool: '序列号检索工具',
        text_sninput: "请输入需要检索的SN号，SN之间请以'-'隔开",
        button_searchsns: '开始检索',
        text_loadingsearch: '数据量较大，查询时间可能较长，请耐心等待',
        text_repeat: '以下序列号有多条出库数据，已显示第一条，请手动查询',
        text_notfound: '以下序列号在K3中没有寻找到出库数据(序列号错误或未出库)',
        text_error: '以下序列号K3无法自动查询，请手动查询',
        text_success: '以下序列号查询正常，请仔细核对',
        label_sn: '序列号',
        label_mfid: '物料编号',
        label_mname: '物料名称',
        label_customer: '客户',
        label_outstockno: '销售出库单号',
        label_outstocktime: '出库时间',
        label_orderno: '销售订单号',
        label_duration: '已出库时间(月)',
        notify_inputsnerr: '某个序列号格式不对，请调整后重试',
      },
      webstore: {
        label_contents: 'Webstore订单总数：',
        label_contents_s: 'Shopify订单总数：',
        btn_updateorder: '更新',
        btn_getorder: '下载',
        label_options: '操作',
        label_status: '状态',
        label_k3_id: 'K3订单编号',
        label_wid: 'Webstore订单编号',
        label_actual_order_id: 'Shopify订单ID',
        label_sid: 'Shopify订单编号',
        label_currency: '币别',
        label_fullname: '联系人',
        label_shippingtotal: '总运费',
        label_taxtotal: '总税费',
        label_discounttotal: '总折扣',
        label_total: '总费用',
        label_item: '产品',
        label_shipping: '物流信息',
        label_billing: '发票信息',
        label_notes: '备注信息',
        title_setorderstatus: '变更状态',
        notify_no_processingorder: '暂无更新，请点击下载。',
        notify_no_fids: '本地无订单，请求更新中。。。',
        notify_update_total: '更新订单的数量为：',
        notify_no_localorder: '本地无的订单，请更新。',
        notify_np_localproduct: '本地无任何产品，资源服务器错误。',
        notify_no_portal_id: '以下订单信息不完整，已被系统拦截：',
        tip_checkup: '审核',
        tip_recall: '撤回',
        tip_callback: '同步物流信息',
        tip_upload: '标记发货',
        notify_record_failed: '日志记录失败。',
        notify_status_failed: '订单状态变更失败。',
        notify_save_repeatly: '不要重复审核订单，请刷新。',
        notify_worder_completed: '物流信息和订单状态已成功同步至Webstore',
      },
    },
    page: {
      login: {
        dragtext: '请将滑块拖动到右侧',
        dragtextsucc: '验证成功',
        loadingviadingtalk: '验证钉钉身份中，请稍候...',
        notify_dingtalk_not_bound:
          '当前用户未绑定钉钉，请前往管理页面自行绑定或联系管理员',
      },
      home: {
        cart: '加入购物车',
        tooltip_todetails: '点击前往详情页',
        notify_series_outofsize: '该系列下产品太多，请手动加入购物车！',
        notice_demoprice_dealer: '这是仅供代理商的样品价格',
        notice_goldbar: 'Order one GOld bar for every 10x Standard GO bar.',
      },
      details: {
        price: '单价',
        quantity: '数量：',
        pageheader_title: '返回',
        pageheader_details: '商品详情',
        label_weight: '单位净重： ',
        label_rweight: '整箱重量： ',
        label_sku: 'SKU No.： ',
        label_ean: 'EAN/Barcode： ',
        label_boxpcs: '产品数量/箱： ',
        label_feature: '包装箱尺寸： ',
        label_description: '产品描述：',
      },
      cart: {
        head_title: '我的购物车',
        empty_cart: '购物车空空如也~',
        empty_cart_url: '去购物',
        text_total: '总计：',
        text_weight: '重量:',
        btn_clearcart: '清空购物车',
        btn_checkout: '去结算',
        tooltip_refresh_cart: '刷新购物车',
        productimage: '产品图片',
        productname: '产品名称',
        productprice: '价格',
        productdiscount: '折扣率(%)',
        productdisprice: '折后价',
        ladderPrice: '优惠价',
        ladderRange: '优惠区间',
        productquantity: '数量',
        productsubprice: '小计',
        productoption: '选项',
        text_clearcartconfirm_body: '清空购物车？',
        text_clearcartconfirm_title: '信息',
        btn_clearcart_confirm: '清空',
        btn_clearcart_cancel: '取消',
        message_clearcart_delete: '操作成功',
        message_clearcart_cancel: '取消操作',
        tag_modifyquantity: "点击'√'来确认修改某个产品数量。",
        label_least_total: '目标金额:',
        label_least_weight: '目标重量:',
        air_alert: '购买ZEN Air系列时，总数量需要之和需要大于30件。',
      },
      orderconfirm: {
        notice_modifyadd: '如果您想修改地址，请进入右上角头像中的个人中心操作',
        address_title: '收货信息',
        receipt_title: '发票信息',
        delivery_title: '交货方式',
        payment_title: '付款方式',
        details_title: '订单明细',
        address_add: '使用其他地址',
        title_country: '区域',
        title_province: '省/州',
        title_city: '城市',
        title_zipcode: '邮编',
        title_detailadd: '地址',
        title_contacts: '联系人',
        title_company: '公司',
        title_tel: '联系电话',
        title_email: '联系邮箱',
        title_tag: '标签',
        title_taxno: '税号',
        btn_newadd: '添加',
        text_no_address: '还没有任何地址。',
        radio_delivery_a: '买家自提货物',
        radio_delivery_b: '卖家负责物流',
        notify_delivery_a: '选择该项时，您需要自行安排时间取走您的货物。',
        notify_delivery_b: '当您提交订单后，稍后可以在系统中跟踪物流信息。',
        title_customer_po: '客户订单号',
        title_notes: '订单备注',
        btn_submit: '提交订单',
        tooltip_mintotal_weight: '目标金额或目标重量不够会导致您无法提交订单',
        notify_check_shippingaddress: '请选择一项收货地址',
        notify_check_receiptaddress: '请选择一项发票地址',
        notify_check_deliveryterms: '请选择一种交付方式',
        notify_check_details: '订单中没有物品，无法提交订单',
        notify_check_mintotal_minweight:
          '您订单中最小订单金额或最少订单重量不够',
        notify_product_outofselling: '您购物车中存在已下架的产品，请确认。',
        notify_normal_err_code: 'Error code: -1',
        notify_email_error: '邮箱格式错误',
        notify_warn: '警告',
        notify_full_address_java: '最多可以保存10条地址信息！请勿非法操作！',
        notify_pricemodified:
          '购物车中以下产品价格已更新或下架，请刷新页面或删除产品重新添加： ',
        notify_email_exception: '邮件服务异常，您可能收不到通知邮件',
        quantity_unupdate_error: '商品总计错误，请核对或刷新',
        copyToInvoice_notice:
          '将复制该收货地址到发票地址，请确保发票地址少于10个，继续吗？',
        title_feedback: '客户满意度调查',
        tip_feedback: '为了提供更好的服务，请给予我们您宝贵的意见和建议！',
        why: '为什么',
        question_unfinished: '未完成的题目：题目',
        notify_feedback_success: '感谢您的反馈！',
      },
      orderform: {
        notice_tips0:
          '您随时可以通过进入右上角的个人中心来访问此订单页面来追踪您的订单进度',
        ordersstatus_title: '订单状态',
        shipping_title: '收货信息',
        receipt_title: '发票信息',
        payment_title: '付款信息',
        other_title: '出货信息',
        details_title: '订单明细',
        list_title: '发货清单',
        shipping_contacts: '联系人:',
        shipping_address: '详细地址:',
        shipping_country: '区域:',
        shipping_province: '省/州:',
        shipping_city: '城市:',
        shipping_zipcode: '邮编:',
        shipping_tel: '电话:',
        shipping_email: '邮箱:',
        span_current_body0: '客户订单号：',
        span_current_body1: '订单号：',
        span_current_body2: '，当前状态：',
        span_time_zone: '时区：',
        span_total: '总计：',
        span_totalWeight: '重量:',
        span_no_receiptimg: '暂时还没有发票。',
        span_no_packinglist: '暂时还没有装箱单。',
        span_no_commercialinvoice: '暂时还没有商业发票。',
        span_paymentupload_body1: '将文件拖到此处，或',
        span_paymentupload_body2: '点击上传',
        span_tip_upload: '仅支持jpg/png，且文件大小在5MB以内',
        span_img_packinglist: '装箱单',
        span_img_cominvoice: '商业发票',
        notify_upload_success: '上传成功',
        tag_notice_skip_payment:
          ' 提示：如果您想跳过上传付款凭证，请联系我们的工作人员。',
        tag_notice_payment:
          ' 当我们的工作人员确认您上传的付款凭证后将为您更新订单状态。',
        tag_notice_modifydetails:
          ' 提示：出货前，您可以通过编辑订单留言来告知我们您订单的任何改动，但我们只能看到您最后一次提交的内容。',
        btn_done: '完成',
        notify_notessuccess: '我们已经收到您的留言。',
        tag_pickupself: ' 如果您选择了自提货物，将不会有任何物流跟踪信息。',
        btn_sign: '确认收货',
        span_ordercompleted: '该订单已完成。',
        notify_confirmorder_success: '确认成功',
        notify_repeat_confirm: '请勿重复确认订单',
        text_logistics_no: '物流单号:',
        text_time: '时间:',
        title_batchtable: '发货明细',
        title_tracking: '物流跟踪',
        btn_postapi: '获取',
        text_track_tip: "点击'获取'按钮来获取物流跟踪信息",
        tag_ad_notice: ' 物流跟踪区域广告由第三方提供，非本平台广告',
      },
      center: {
        tab_info: '我的基础信息',
        tab_order: '我的订单',
        tab_shipping: '我的收货地址',
        tab_receipt: '我的发票地址',
        label_order_number: '实体:',
        label_order_fid: '订单编号:',
        label_order_custpo: '客户订单号:',
        label_order_createtime: '创建时间:',
        radio_orderlist_all: '全部',
        radio_orderlist_processing: '待确认',
        radio_orderlist_finished: '已完成',
        btn_message_confirm: '确认',
        btn_message_cancel: '不，取消',
        text_delete_message_body: '真的要删除吗？',
        text_delete_message_title: '请确认',
        delete_address_success: '已删除',
        empty_address: "没有任何地址，点击'新增'一个新地址",
        btn_add: '新增',
        notify_title_notification: '信息',
        notify_full_address: '最多可以保存10条地址信息',
        notify_normal_err_code: 'Error code: -1',
        notify_address_null: '信息不完整',
        notify_email_error: '邮箱格式错误',
        message_success: '保存成功',
        message_resetpasssuccess: '密码重置成功，3秒后跳到登录页面',
        notify_warn: '警告',
        notify_full_address_java: '最多可以保存10条地址信息！请勿非法操作！',
        message_cancel: '已取消',
        btn_resetpassword: '重置密码',
        title_reset_password: '重置密码',
        label_newpass: '新密码',
        btn_save: '保存',
        tooltip_email: '邮箱将用于推送通知',
        notify_nochange: '无改动',
        notify_password_length: '密码应在3-15个字符内',
        label_ccemail: '辅助邮箱',
        alert_ccemail:
          '辅助邮箱用于接收您一封包含您下单详情的邮件，您最多可设置5个辅助邮箱地址',
      },
      console: {
        tip_refresh: '获取更新',
        router_information: '我的账号信息',
        router_settings: '个人设置',
        router_logout: '注销',
        menuitem_user: '—— 用户管理 ——',
        menuitem_order: '—— 订单商城 ——',
        menuitem_webstore: '—— 电商平台 ——',
        menuitem_product: '—— 产品管理 ——',
        menuitem_3pl: '—— 第三方物流 ——',
        menuitem_properties: '—— 基础资料 ——',
        menuitem_feedback: '—— 反馈 ——',
        menuitem_settings: '—— 系统设置 ——',
        menuitem_aftersales: '—— 工具 ——',
        menuitem_data: '—— 数据 ——',
        dataplatform: '—— 数据中台 ——',
        shopify: '订单管理',
        childmenuitem_controluser: '控制台',
        childmenuitem_customer: '国际客户',
        childmenuitem_domesticcustomer: '中国客户',
        childmenuitem_orderlists: '国际订单',
        childmenuitem_domesticorder: '中国订单',
        childmenuitem_quickorder: '快速下单',
        childmenuitem_order: 'iFi Webstore',
        childmenuitem_order1: 'iFi Shopify',
        childmenuitem_globalemail: '邮件通知',
        childmenuitem_synproducts: '同步与设置',
        childmenuitem_pricingrules: '计价规则',
        childmenuitem_discountrules: '折扣率规则',
        childmenuitem_pricesystem: 'Master Pack价格配置',
        childmenuitem_country: '区域',
        childmenuitem_currency: '币种',
        childmenuitem_exchangerate: '汇率',
        childmenuitem_unit: '测量单位',
        childmenuitem_paymentterms: '付款方式',
        childmenuitem_ordertatus: '订单状态',
        childmenuitem_brand: '品牌',
        childmenuitem_satisfacation: '满意度调查',
        childmenuitem_general: '通用',
        childmenuitem_permissions: '权限',
        childmenuitem_sn: '序列号工具',
        childmenuitem_statistics: '统计',
        childmenuitem_analysis: '分析',
        childmenuitem_bigdata: '大数据',
        childmenuitem_g_standardorder: '标准订单',
        childmenuitem_g_platformorder: '电商订单',
        topexplain: '使用左侧功能栏选择功能。',
      },
    },
    ordermanage: {
      order: '订单',
      query: '查询',
      list: '列表',
      number: '编号',
      type: '类型',
      status: '状态',
      reset: '重置',
      status1: '待同步',
      status2: '已同步',
      status3: '已发货',
      status4: '已作废',
      update: '更新状态',
      country: '国家',
      currency: '币别',
      qty: '数量',
      total: '总费用',
      logistics: '物流',
      source: '订单来源',
      detail: '订单明细',
      abnormal: '异常',
      info: '消息',
      sourcedata: '源数据',
      customer: '客户',
      organization: '发货组织',
      province: '省/州/地址',
      city: '城市',
      contactPerson: '联系人',
      postCode: '邮编',
      address: '地址',
      other: '其他',
      basicInfo: '基本信息',
      detail: '明细',
      materialCode: '物料编码',
      materialName: '物料名称',
      specifications: '规格型号',
      bomVersion: 'BOM版本',
      inventoryOrganization: '库存组织',
      warehouse: '仓库',
      unitPrice: '含税单价',
      totalAmount: '合计金额',
      discount: '折扣',
      tax: "税费",
      shippding: "运费",
      view: "查看",
      pending: "待处理（初始状态）",
      created: "销售订单已创建（未提交）",
      submitted: "销售订单已提交（待审核）",
      audited: "销售订单已审核（待下推发货通知单）",
      created1: "发货通知单已创建",
      filled: "物流信息已回填（发货通知单待提交）",
      submitted1: "发货通知单已提交（待审核）",
      audited1: "发货通知单已审核（待下推销售出库单）",
      created2: "销售出库单已创建（待回填 SN）",
      snfilled: "销售出库单SN已回填（待提交）",
      submitted2: "销售出库单已提交（待审核）",
      audited2: "销售出库单已审核（自动下推应收成功）",
      k3generated: "K3 应收单生成完成（流程结束）",
      Processing: "处理中",
      Completed: "已完成",
      Cancel: "失效",
      detail: "详情",
      code: "编码",
      createtime: "创建时间",
      cancleTip: "是否将此订单置为失效状态？失效后不可复原。",
      pushToK3: "手动将此订单推送至K3,手动推送没有校验库存，请检查库存是否充足。",
      updateTip: "重新启动自动化定时任务",
      platformStatus: "发货状态",
      pstatus1: "待发货",
      pstatus2: "已发货",
      notes: "备注",
      transport: "运输",
      jingdong: "京东",
      jindongTip: "是否确认开启/关闭京东物流",
      jingdongPush: "京东物流推送",
      returnGoods: "部分退货",
      jd: "京东",
      barn: "谷仓",
      cancleReason: "取消原因",
      jindongPushTip: "程序已执行，请等待2分钟"
    },
  }
}



// WEBPACK FOOTER //
// ./src/assets/i18n/cn.js